export interface StockItemHeaderAddRemove {
  purchaseInvoiceId: string;
  stockItemHeaderId: string;
  purchaseInvoiceQuantity: number;
  purchaseInvoiceValue: number;
  purchaseInvoicePrice: number;
}
